import React from "react";
import {
	usePermissions,
	useTranslate,
	useRefresh,
	FunctionField,
	Loading,
	Confirm,
	TextField,
	Datagrid,
	ListContextProvider
} from "react-admin";
import {
	Card,
	Button,
	Typography
} from "@material-ui/core";
import { httpClient } from "api/httpClient";
import { useNotifyError } from "utils/notifiers/useNotifyError";
import { useTerminalsContext } from "contexts/TerminalsProvider";
import { useNotifySuccess } from "utils/notifiers/useNotifySuccess";

import { CardBlock } from './CardBlock';


export const DutyManagerBlock = () => {
	const refresh = useRefresh();
	const translate = useTranslate();
	const notifyError = useNotifyError();
	const notifySuccess = useNotifySuccess();

	const { permissions } = usePermissions();
	const { data, loading, ids } = useTerminalsContext();

	const [localTerminals, setLocalTerminals] = React.useState(data);
	const [openConfirmationPopup, setOpenConfirmationPopup] = React.useState(false);
	const [selectedTerminal, setSelectedTerminal] = React.useState({});
	const [isLoading, setIsLoading] = React.useState(false);

	React.useEffect(() => {
		if(data){
			setLocalTerminals(data);
		}
	}, [data]);

	if (!permissions || !localTerminals || !data) return null;
	if (loading || isLoading) return <Loading loadingSecondary="" />;

	const handleBecomeDutyManager = (terminalId) => {
		setIsLoading(true);
	
		httpClient(`/terminal/${terminalId}`, {
			method: "PATCH",
			body: JSON.stringify({
				duty_manager_id: permissions.id,
			}),
		})
			.then((res) => res.json)
			.then((res) => {
				if (res.error) {
					notifyError(res.error);
				} else {
					notifySuccess(
						translate("tab.duty_manager.success").replace(
							"{terminal_name}",
							data[terminalId].name
						)
					);
					setLocalTerminals((prev) => {
						const updated = { ...prev };
						console.log(res)
						updated[terminalId].duty_manager_id = permissions.id;
						updated[terminalId].duty_manager_name = res.duty_manager_name;
						return updated;
					});
					refresh();
				}
			})
			.catch((err) => {
				notifyError(err.message);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};
	

	const openConfirmation = (terminalId, terminalName) => {
		setSelectedTerminal({ terminalId, terminalName });
		setOpenConfirmationPopup(true);
	};

	const closeConfirmation = () => {
		setOpenConfirmationPopup(false);
		setSelectedTerminal({});
	};

	const confirmAction = () => {
		if (selectedTerminal) {
			handleBecomeDutyManager(selectedTerminal.terminalId);
			closeConfirmation();
		}
	};

	const listContextValue = {
		resource: "terminals",
		data: localTerminals,
		ids: ids || Object.keys(localTerminals).map(id => parseInt(id, 10)),
		total: (ids || Object.keys(localTerminals)).length,
		currentSort: { field: 'id', order: 'ASC' },
		sort: { field: 'id', order: 'ASC' },
		page: 1,
		perPage: 1000, 
	  };
		
	return (
		<CardBlock mt={4} component={Card}>
			<Typography variant="h6" style={{ fontWeight: 600, marginBottom: 16 }}>
				Terminals
			</Typography>
			<ListContextProvider value={listContextValue}>
				<Datagrid rowClick={false}>
					<TextField source="name" label="Terminal Name" sortable={false}/>
					<FunctionField sortable={false}
						label={translate("tab.duty_manager.name")}
						render={(record) => (
							<Typography variant="body1" style={{ paddingLeft: 15 }}>
								{record?.duty_manager_name ?? translate('tab.duty_manager.no_manager')}
							</Typography>
						)}
					/>
					<FunctionField sortable={false}
						label="Action"
						render={(record) => (
							<Button
								variant="outlined"
								size="small"
								onClick={() => openConfirmation(record.id, record.name)}
								disabled={record.duty_manager_id === permissions.id}
								>
								{translate('tab.duty_manager.become_duty_manager')}
							</Button>
						)}
					/>
				</Datagrid>
			</ListContextProvider>
			<Confirm
				isOpen={openConfirmationPopup}
				content={translate("tab.duty_manager.confirm_become_manager").replace("{terminal_name}", selectedTerminal.terminalName)}
				title={translate("osfc.buttons.confirm")}
                confirm={translate("osfc.buttons.confirm")}
                cancel={translate("osfc.buttons.cancel")}
				onConfirm={confirmAction}
				onClose={closeConfirmation}
			/>			
		</CardBlock>
	);
};
